export const MAX_NAME_LENGTH = 100;
export const MAX_ADDRESS_LENGTH = 150;
export const MAX_ADDITIONAL_INFORMATION_LENGTH = 1000;
